import {
  BrowserRouter as Router,
  Route,
  Switch,
} from "../node_modules/react-router-dom";
import Header from "./component/Header";
import Nav from "./component/Nav";
import DASHBOARD from "./view/dashboard";
import AZMOON_LIST from "./view/azmoon-list/insex"; 
import STORE from "./view/store";
import STORE_PRODUCT from "./view/store/STORE_PRODUCT";
import AS_STORE_PRODUCT from "./view/store/AS_STORE_PRODUCT";
import MHeader from "./component/mobile/M_Header";
import MNav from "./component/mobile/M_Nav";
import LOGIN from "./view/login";
// import MobileLoginPages from "./component/login/MobileLoginPages";
// import DesktopLogin from "./component/login/DesktopLogin";
// import Links from "./component/login/Links";
import HOME from "./view/home";
import ENTER_EXAM from "./view/azmoon-list/ENTER_EXAM";
import EXAM from "./view/azmoon-list/EXAM";
import CART from "./view/cart";
import EXAM_RESULT from "./view/exam-result/EXAM_RESULT";
import CALENDAR from "./view/calendar";
import FINANCIAL from "./view/financial";
import BLOG from "./view/blog";
import PROFILE from "./view/profile";
import CONTACTuS from "./view/contact-us";
// import { useState } from "react";
import { useSelector } from "react-redux";
import MHNav from "./component/mobile/MHNav";
import REGISTER from "./view/register";
import MESSAGES from "./view/messages";

function App() {
  const state = useSelector((state) => state.default);
  // const [showNav, setShowNav] = useState(state.ShowDashNav);
  return (
    <Router>
      <div className="App">
        {window.innerWidth > 1000 &&
          window.location.pathname.includes("dashboard") && <Header />}
        {window.innerWidth < 1000 && <MHeader />}
        {window.innerWidth > 1000 &&
          window.location.pathname.includes("dashboard") && <Nav />}
        {((window.innerWidth < 1000) && (state.MNavDataType===2)) && <MNav />}
        {((window.innerWidth < 1000) && (state.MNavDataType===1)) && <MHNav />}
        {/* <Links /> */}
        <Switch>
          <Route exact path="/">
            <HOME />
          </Route>
          <Route exact path="/contact_us">
            <CONTACTuS />
          </Route>
          <Route exact path="/dashboard">
            <DASHBOARD />
          </Route>
          <Route exact path="/dashboard/profile">
            <PROFILE />
          </Route>
          <Route exact path="/dashboard/calendar">
            <CALENDAR />
          </Route>
          <Route exact path="/dashboard/blog">
            <BLOG />
          </Route>
          <Route exact path="/dashboard/financial">
            <FINANCIAL />
          </Route>
          <Route exact path="/dashboard/messages">
            <MESSAGES/>
          </Route>
          <Route exact path="/dashboard/cart">
            <CART />
          </Route>
          <Route exact path="/dashboard/azmoon_list">
            <AZMOON_LIST />
          </Route>
          <Route exact path="/dashboard/store">
            <STORE />
          </Route>
          <Route exact path="/dashboard/store/:id">
            <STORE_PRODUCT />
          </Route>
          <Route exact path="/dashboard/store/amazing-suggest/:id">
            <AS_STORE_PRODUCT />
          </Route>
          <Route exact path="/dashboard/azmoon_list/enter_exam/:id">
            <ENTER_EXAM />
          </Route>
          <Route exact path="/dashboard/azmoon_list/exam-result/:id">
            <EXAM_RESULT />
          </Route>
          <Route exact path="/dashboard/azmoon_list/exam/:id">
            <EXAM />
          </Route>
          <Route exact path="/login">
            <LOGIN />
          </Route>
          <Route exact path="/register">
            <REGISTER/>
          </Route>
          {/* {window.innerWidth > 945 ? <DesktopLogin /> : <MobileLoginPages />} */}
        </Switch>
      </div>
    </Router>
  );
}

export default App;
